import { Button, Dialog, DialogContent, Grid, Stack } from '@mui/material';
import { PopupTransition } from 'components/@extended/Transitions';
import { BasicTableNoPagination } from 'components/common/Table';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { Row } from 'react-table';
import Amount from 'components/common/Amount';
import { IUser } from 'types/custom/user';
import { Typography } from '@mui/material';

interface Props {
  open: boolean;
  setOpen: (status: boolean) => void;
  users: Record<string, any>[] | null;
}

export default function ViewUsersModal({ open, users, setOpen }: Props) {
  const theme = useTheme();

  const handleCancel = () => {
    setOpen(false);
  };
  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        className: 'cell-center',
        Cell: ({ row }: { row: Row }) => {
          return <>{row.index + 1}</>;
        }
      },
      {
        Header: 'Name',
        accessor: 'name',
        Cell: ({ row }: { row: Row }) => {
          const user = row.original as IUser;
          return <span>{`${user?.firstName ?? '_ '} ${user?.lastName ?? '_'}`}</span>;
        }
      },
      {
        Header: 'Broker',
        accessor: 'broker',
        Cell: ({ row }: { row: Row }) => {
          const user = row.original as IUser;
          return <span>{user.broker ?? '_'}</span>;
        }
      },
      {
        Header: 'Margin',
        accessor: 'margin',
        Cell: ({ row }: { row: Row }) => {
          const user = row.original as IUser;
          return <Amount variant="subtitle2" amount={user?.portfolio?.balance ?? 0} />;
        }
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [users, theme]
  );

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="sm"
      aria-labelledby="order-confirmation-title"
      aria-describedby="order-confirmation-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Grid
          container
          spacing={0}
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: '1px solid {theme.palette.divider}', p: 2 }}
        >
          <Typography variant="h4" sx={{ ml: 1 }}>
            Logged In Users List
          </Typography>
        </Grid>
        <Stack alignItems="center" spacing={3.5}>
          <Stack spacing={2}>
            <BasicTableNoPagination columns={columns} data={users ?? []} emptyMessage="No users found!" />
          </Stack>
          <Stack direction="row" spacing={2} sx={{ width: 1 }} justifyContent="end">
            <Button fullWidth onClick={handleCancel} color="secondary" variant="outlined">
              Close
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
